
import { createContext, useMemo } from 'react';
import { PopoverActions } from '../../../../../../BaseComponents/Popover/EDPopover';

interface IAppointmentTooltipContext {
  actions: React.RefObject<PopoverActions | null> | null;
}

const defaultValues: IAppointmentTooltipContext = {
  actions: null,
};

export const AppointmentTooltipContext =
  createContext<IAppointmentTooltipContext>(defaultValues);

export const AppointmentTooltipContextProvider: React.FC<
  React.PropsWithChildren<IAppointmentTooltipContext>
> = props => {
  const value: IAppointmentTooltipContext = useMemo(
    () => ({ actions: props.actions }),
    [props.actions]
  );
  return (
    <AppointmentTooltipContext.Provider value={value}>
      {props.children}
    </AppointmentTooltipContext.Provider>
  );
};
